import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import useStyles from "../../../../styles/styles";
import { Card, CardActionArea, CardContent, Grid, Typography } from "@mui/material";
import { Link, Outlet, useLocation } from "react-router-dom";

const tabNames = ["info", "observations", "tests", "diagnoses", "treatments","bills","receipts"];

const Appointment = () => {
  const classes = useStyles();
  const [chosenInfo, setChosenInfo] = useState<string>("info");
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    // eslint-disable-next-line array-callback-return
    tabNames.map((name) => {
      if (pathname.includes(name)) setChosenInfo(name);
    });
  }, [pathname]);

  return (
    <>
      <>
        <Box sx={{ width: "100%", mb: 3 }}>
          <Box sx={{ bgcolor: "#fff", p: 4 }}>
            <Grid container spacing={2} direction="row" alignItems="center" justifyContent="center">
              <Grid item xs={4} md={1.5}>
                <Link to="info" style={{ textDecoration: "none" }}>
                  <Card>
                    <CardActionArea
                      href=""
                      style={{ display: "flex", justifyContent: "center" }}
                      className={chosenInfo === "info" ? classes.pressedButton : classes.unPressedButton}
                      onClick={() => {
                        setChosenInfo("info");
                      }}
                    >
                      <CardContent>
                        <Typography>Appointment</Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Link>
              </Grid>
              <Grid item xs={4} md={1.5}>
                <Link to="observations" style={{ textDecoration: "none" }}>
                  <Card>
                    <CardActionArea
                      href=""
                      style={{ display: "flex", justifyContent: "center" }}
                      className={chosenInfo === "observations" ? classes.pressedButton : classes.unPressedButton}
                      onClick={() => {
                        setChosenInfo("observations");
                      }}
                    >
                      <CardContent>
                        <Typography>Observations</Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Link>
              </Grid>
              <Grid item xs={4} md={1.5}>
                <Link to="tests" style={{ textDecoration: "none" }}>
                  <Card>
                    <CardActionArea
                      href=""
                      style={{ display: "flex", justifyContent: "center" }}
                      className={chosenInfo === "tests" ? classes.pressedButton : classes.unPressedButton}
                      onClick={() => {
                        setChosenInfo("tests");
                      }}
                    >
                      <CardContent>
                        <Typography>Tests</Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Link>
              </Grid>
              <Grid item xs={4} md={1.5}>
                <Link to="diagnoses" style={{ textDecoration: "none" }}>
                  <Card>
                    <CardActionArea
                      href=""
                      style={{ display: "flex", justifyContent: "center" }}
                      className={chosenInfo === "diagnoses" ? classes.pressedButton : classes.unPressedButton}
                      onClick={() => {
                        setChosenInfo("diagnoses");
                      }}
                    >
                      <CardContent>
                        <Typography>Diagnoses</Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Link>
              </Grid>
              <Grid item xs={4} md={1.5}>
                <Link to="treatments" style={{ textDecoration: "none" }}>
                  <Card>
                    <CardActionArea
                      href=""
                      style={{ display: "flex", justifyContent: "center" }}
                      className={chosenInfo === "treatments" ? classes.pressedButton : classes.unPressedButton}
                      onClick={() => {
                        setChosenInfo("treatments");
                      }}
                    >
                      <CardContent>
                        <Typography>Treatments</Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Link>
              </Grid>
              <Grid item xs={4} md={1.5}>
                <Link to="bills" style={{ textDecoration: "none" }}>
                  <Card>
                    <CardActionArea
                      href=""
                      style={{ display: "flex", justifyContent: "center" }}
                      className={chosenInfo === "bills" ? classes.pressedButton : classes.unPressedButton}
                      onClick={() => {
                        setChosenInfo("bills");
                      }}
                    >
                      <CardContent>
                        <Typography>Bills</Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Link>
              </Grid>
              <Grid item xs={4} md={1.5}>
                <Link to="receipts" style={{ textDecoration: "none" }}>
                  <Card>
                    <CardActionArea
                      href=""
                      style={{ display: "flex", justifyContent: "center" }}
                      className={chosenInfo === "receipts" ? classes.pressedButton : classes.unPressedButton}
                      onClick={() => {
                        setChosenInfo("receipts");
                      }}
                    >
                      <CardContent>
                        <Typography>Receipts</Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Outlet />
      </>
    </>
  );
};

export default Appointment;
